import React, { Component } from "react";
import Typography from "material-ui/Typography";
import { CircularProgress } from "material-ui/Progress";
import ReactTable from "react-table";
import "react-table/react-table.css";
import QueryService from "./QueryService";

class MediafilesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mediafiles: [],
      error: false,
      errorMessage: null,
      uploadError: null,
      uploadSuccess: false,
      uploading: false,
      loading: true,
    };
    this.new_file_note = React.createRef();
    this.new_file_file = React.createRef();
  }

  getServerState() {
    this.setState({ loading: true, error: false });
    QueryService.get("/mediafiles")
      .then((json) => {
        this.setState({ mediafiles: json.data, loading: false, error: false });
      })
      .catch((err) => {
        console.error(
          "cannot fetch mediafiles, could be redirection error due to not being logged in",
          err,
        );
        let errorMessage = "Failed to load media files. ";
        if (err.status === 401 || err.status === 403) {
          errorMessage += "Please log in to view media files.";
        } else if (err.status >= 500) {
          errorMessage += "Server error. Please try again later.";
        } else {
          errorMessage += "Please check your connection and try again.";
        }
        this.setState({ error: true, errorMessage, loading: false });
      });
  }

  componentDidMount() {
    this.getServerState();
  }

  createNewMediafile = (event) => {
    event.preventDefault();

    // Clear previous messages
    this.setState({ uploadError: null, uploadSuccess: false });

    const note = this.new_file_note.current.value;
    const file = this.new_file_file.current.files[0];

    if (!note || !file) {
      this.setState({ uploadError: "Please provide both a note and a file." });
      return false;
    }

    // Set uploading state to true
    this.setState({ uploading: true });

    const fd = new FormData();
    fd.append("media_file[note]", note);
    fd.append("media_file[file]", file);

    QueryService.postForm("/mediafiles", fd)
      .then(() => {
        // Clear form on success
        this.new_file_note.current.value = "";
        this.new_file_file.current.value = "";
        this.setState({
          uploadSuccess: true,
          uploadError: null,
          uploading: false,
        });
        this.getServerState();
      })
      .catch((err) => {
        console.error("Error uploading media file:", err);

        let errorMessage = "Failed to upload media file.";

        // Handle specific error cases
        if (err.status === 401 || err.status === 403) {
          errorMessage =
            "Unauthorized: You do not have permission to upload files. Please log in again.";
        } else if (err.status === 413) {
          errorMessage = "File is too large. Please upload a smaller file.";
        } else if (err.status === 422) {
          errorMessage = `Validation error: ${err.message}`;
        } else if (err.status === 500) {
          errorMessage =
            "Server error: The server encountered an error processing your request. Please try again later.";
        } else if (err.status >= 400 && err.status < 500) {
          errorMessage = `Client error: ${err.message}`;
        } else if (err.message) {
          errorMessage = err.message;
        }

        this.setState({
          uploadError: errorMessage,
          uploadSuccess: false,
          uploading: false,
        });
      });

    return false;
  };

  deleteMediaFile = (mediafile_id) => {
    if (window.confirm("are you sure?")) {
      QueryService.deleteResource(`/mediafiles/${mediafile_id}`)
        .then(() => {
          this.getServerState();
        })
        .catch((err) => {
          console.error("Error deleting media file:", err);

          let errorMessage = "Failed to delete media file. ";
          if (err.status === 401 || err.status === 403) {
            errorMessage += "Please log in to delete media files.";
          } else if (err.status === 404) {
            errorMessage += "Media file not found.";
          } else if (err.status >= 500) {
            errorMessage += "Server error. Please try again later.";
          } else if (err.message && err.message.includes("Failed to fetch")) {
            errorMessage +=
              "Network error. Please check your connection and try again.";
          } else {
            errorMessage += err.message || "Please try again.";
          }

          this.setState({ error: true, errorMessage });
        });
    }
    return false;
  };

  render() {
    const {
      mediafiles,
      error,
      errorMessage,
      uploadError,
      uploadSuccess,
      uploading,
      loading,
    } = this.state;

    // Show loading spinner while fetching data
    if (loading) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "50px",
          }}
        >
          <CircularProgress size={40} />
          <Typography style={{ marginTop: "20px" }}>
            Loading media files...
          </Typography>
        </div>
      );
    }

    // Show error with retry button
    if (error) {
      return (
        <div style={{ padding: "20px" }}>
          <Typography
            variant="title"
            style={{ color: "#721c24", marginBottom: "10px" }}
          >
            Error Loading Media Files
          </Typography>
          <div
            style={{
              padding: "15px",
              backgroundColor: "#f8d7da",
              color: "#721c24",
              marginBottom: "15px",
              borderRadius: "4px",
            }}
          >
            {errorMessage || "An error occurred while loading media files."}
          </div>
          <button
            onClick={() => this.getServerState()}
            style={{ padding: "10px 20px", cursor: "pointer" }}
          >
            Retry
          </button>
        </div>
      );
    }

    // Show media files content
    if (true) {
      const columns = [
        {
          Header: "File URL",
          accessor: "attributes.file.url",
          Cell: (props) => (
            <a href={props.value} target="_blank" rel="noopener noreferrer">
              {props.value}
            </a>
          ),
        },
        {
          Header: "Note",
          accessor: "attributes.note",
          Cell: (props) => <Typography>{props.value}</Typography>,
        },
        {
          Header: "Preview",
          accessor: "attributes.file.url",
          Cell: (props) => {
            if (props.value && props.value.endsWith(".pdf")) {
              return <Typography>pdf</Typography>;
            } else {
              return <img src={props.value} width="200" alt=""></img>;
            }
          },
        },
        {
          Header: "Action",
          accessor: "id",
          Cell: (props) => (
            <button onClick={() => this.deleteMediaFile(props.value)}>
              Delete
            </button>
          ),
        },
      ];

      return (
        <div>
          <Typography variant="title">Media files</Typography>
          Upload a new media file
          <form onSubmit={this.createNewMediafile}>
            <fieldset disabled={uploading}>
              {uploadSuccess && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    marginBottom: "10px",
                    borderRadius: "4px",
                  }}
                >
                  Media file uploaded successfully!
                </div>
              )}
              {uploadError && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    marginBottom: "10px",
                    borderRadius: "4px",
                  }}
                >
                  {uploadError}
                </div>
              )}
              <label>Note</label>
              <input
                type="text"
                ref={this.new_file_note}
                disabled={uploading}
              />
              <br />
              <label>Upload file</label>
              <input
                type="file"
                ref={this.new_file_file}
                disabled={uploading}
              />
              <br />
              {uploading ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <CircularProgress size={20} />
                  <span>Uploading...</span>
                </div>
              ) : (
                <input type="submit" value="Upload new file" />
              )}
            </fieldset>
          </form>
          <ReactTable
            data={mediafiles}
            columns={columns}
            className="-striped"
            defaultPageSize={50}
          />
        </div>
      );
    }
  }
}

export default MediafilesPage;



// WEBPACK FOOTER //
// ./src/Mediafiles.js